import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { TableOfContents } from './TableOfContents';
import { ConstitutionArticles } from './ConstitutionArticles';
import { ByLaws } from './ByLaws';
import { QuickLinks } from './QuickLinks';
export function ConstitutionPage() {
  return <PageLayout data-id="element-759">
      <HeaderBanner data-id="element-760" />
      <TableOfContents data-id="element-761" />
      <ConstitutionArticles data-id="element-762" />
      <ByLaws data-id="element-763" />
      <QuickLinks data-id="element-764" />
    </PageLayout>;
}